import PropTypes from 'prop-types';

import { Box, Stack, Tooltip, Typography } from '@mui/material';

const IntervalTooltipContent = (interval) => {
    return (
        <Stack>
            <Typography variant='caption'>
                Intervalo: {interval.minValue}% - {interval.maxValue}%
            </Typography>
            <Typography variant='caption'>
                Ação: {interval.actionLabel} {interval.percentage && `(${interval.percentage}%)`}
            </Typography>
        </Stack>
    )
}

export const IntervalBar = ({ intervalList }) => {

    return (
        <Stack gap={3} mb={3}>
            <Typography fontWeight="bold">Visualização dos Intervalos</Typography>

            <Stack gap={1}>

                <Box sx={{ position: "relative", width: "100%" }}>

                    {/* Original Bar */}
                    <Box
                        sx={{
                            width: "100%",
                            height: 8,
                            bgcolor: "#e0e0e0",
                            borderRadius: 2
                        }}
                    />

                    {/* Colorful Ranges */}
                    {intervalList.map(interval => {

                        const startPercentage = interval.minValue === 0 ? 0 : (interval.minValue - 1)
                        const widthPercentage = (interval.maxValue - startPercentage)

                        return (
                            <Tooltip
                                key={interval.consumptionRangeId}
                                title={IntervalTooltipContent(interval)}
                                arrow
                                placement="top"
                                enterTouchDelay={0}
                                PopperProps={{
                                    modifiers: [
                                        { name: "preventOverflow", enabled: true, options: { altBoundary: true, padding: 8 } },
                                        { name: "flip", enabled: true, options: { fallbackPlacements: ["top-start", "top-end"] } }
                                    ]
                                }}
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: 0,
                                        left: `${startPercentage}%`,
                                        width: `${widthPercentage}%`,
                                        height: 8,
                                        bgcolor: interval.color,
                                        borderRadius: 2
                                    }}
                                />
                            </Tooltip>
                        )
                    })}

                </Box>

                {/* Bar Labels */}
                <Box sx={{ position: "relative", width: "100%" }}>

                    {[...Array(11)].map((_, i) => {

                        const left = `${(i / 10) * 100}%`

                        return (
                            <Box
                                key={i}
                                sx={{
                                    position: "absolute",
                                    top: 0,
                                    left,
                                    transform: i === 0 ? "none" : i === 10 ? "translateX(-100%)" : "translateX(-50%)",
                                    textAlign: i === 0 ? "left" : i === 10 ? "right" : "center",
                                    whiteSpace: "nowrap"
                                }}
                            >
                                <Typography variant="caption">{i * 10}</Typography>
                            </Box>
                        )
                    })}

                </Box>
            </Stack>
        </Stack>
    )
}

IntervalBar.propTypes = {
    intervalList: PropTypes.array.isRequired
}